import React from "react";
import styled from "@emotion/styled";

import { Stage } from "./Stage";
import { GroupedStageOptions, StageOption } from "./types";

export const renderStageOption = (
  label: React.ReactNode,
  value: string | number | undefined,
  options: (StageOption | GroupedStageOptions)[],
) => {
  if (value === undefined) return label;
  const stringValue = String(value);

  // Handle both flat and grouped options
  const flatOptions =
    Array.isArray(options) && options.length > 0 && "options" in options[0]
      ? (options as GroupedStageOptions[]).flatMap((group) => group.options)
      : (options as StageOption[]);

  const selectedOption = flatOptions.find((option) => option.value === stringValue);

  if (!selectedOption) return label;

  const labelAsString = label?.toString() || "";

  return (
    <StageWrapper>
      <Stage
        label={labelAsString}
        color={selectedOption.color}
        iconColor={selectedOption.iconColor}
        iconName={selectedOption.iconName}
      />
    </StageWrapper>
  );
};

export const findStageOptionByValue = (
  value: string | null,
  options: StageOption[] | GroupedStageOptions[],
): StageOption | undefined => {
  if (!value) return undefined;

  // Handle both flat and grouped options
  const flatOptions =
    Array.isArray(options) && options.length > 0 && "options" in options[0]
      ? (options as GroupedStageOptions[]).flatMap((group) => group.options)
      : (options as StageOption[]);

  return flatOptions.find((option) => option.value === value);
};

export const StageWrapper = styled.div({
  lineHeight: "1",
});
